import React from "react";
import { PanelEditUser } from "../../../UI/Users/Edit/PanelEditUser";

const EditUser = () => {
  return (
    <div>
      <PanelEditUser />
    </div>
  );
};

export default React.memo(EditUser);
